/* Belo Box builder — sections/belo2-box-builder.liquid
   State: { qty: {variantId: n}, mode: 'sub'|'once' }
   Maths (integer cents, mirrors the admin automatic discounts applied on
   top of the live selling-plan prices):
     count     = Σ qty
     subtotal  = Σ qty × price            (full one-time price; the strikethrough)
     unit      = mode == 'sub' && item has data-sub-price ? subPrice : price
     base      = Σ qty × unit             (what the cart charges before discounts)
     tierPct   = pct of the highest tier whose qty ≤ count (0 below tier 1)
     total     = round(base × (100 − tierPct) / 100)
     savings   = subtotal − total          (tier + plan savings together)
   data-sub-pct on the root is copy-only and is not used here.
   Add to cart: POST /cart/add.js { items:[…], sections:'cart-drawer' } then the
   theme's eventBus emits (update:cart:drawer → open:cart:drawer), as
   assets/component-product-form.js does.
   Idempotent per root (data-box-init); re-inits on shopify:section:load. */
(function () {
  'use strict';

  if (window.__belo2Box) return;
  window.__belo2Box = true;

  var DEFAULT_TEXT = {
    summaryTitle: 'Your box · {count} jar(s)',
    shipLocked: 'Add {n} more for free shipping',
    shipUnlocked: 'Free shipping unlocked',
    savingsText: 'You save {amount} ({pct}%)',
    savingsLocked: 'Add {min}+ jars to start saving',
    progressText: 'Add {n} more jar(s) to unlock {next}',
    progressDone: 'Maximum savings unlocked',
    ctaLabel: 'Add my box to cart · {total}',
    ctaLockedLabel: 'Add {min}+ jars to build your box',
    miniCta: 'Add to cart · {total}',
    miniCtaLocked: 'Add {min}+ jars',
    ctaLoading: 'Adding your box…',
    errorGeneric: 'Sorry, we couldn’t add your box. Please try again.',
    stickyUnit: 'jar(s)'
  };

  /* ---------- money (port of Shopify.formatMoney; format from shop.money_format) ---------- */
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) number = 0;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(placeholder);
    var value;
    switch (m && m[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, '\'', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '').trim();
  }

  /* ---------- copy templates: {token} replacement + "(s)" plural marker ---------- */
  function fill(tpl, vars, pluralN) {
    var out = String(tpl == null ? '' : tpl);
    Object.keys(vars || {}).forEach(function (k) {
      out = out.split('{' + k + '}').join(String(vars[k]));
    });
    if (typeof pluralN === 'number') out = out.replace(/\(s\)/g, pluralN === 1 ? '' : 's');
    return out;
  }

  function parseJSON(text, fallback) {
    try { return JSON.parse(text); } catch (e) { return fallback; }
  }

  function init(root) {
    if (root.dataset.boxInit) return;
    root.dataset.boxInit = '1';

    var cfgEl = root.querySelector('[data-box-config]');
    var cfg = cfgEl ? parseJSON(cfgEl.textContent, {}) : {};
    var text = {};
    Object.keys(DEFAULT_TEXT).forEach(function (k) {
      var v = cfg.text && cfg.text[k];
      text[k] = (v == null || v === '') ? DEFAULT_TEXT[k] : v;
    });

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var money = function (c) { return formatMoney(c, moneyFormat); };
    var minJars = parseInt(root.dataset.minJars, 10) || 2;
    var giftVariant = (root.dataset.giftVariant || '').trim();
    var giftThreshold = parseInt(root.dataset.giftThreshold, 10) || 0;
    var giftAdd = root.dataset.giftAdd === 'true' && !!giftVariant;
    var gift2Variant = (root.dataset.gift2Variant || '').trim();
    var gift2Threshold = parseInt(root.dataset.gift2Threshold, 10) || 0;
    var gift2Add = root.dataset.gift2Add === 'true' && !!gift2Variant;
    var shipThreshold = parseInt(root.dataset.shipThreshold, 10) || 0;

    var tiers = parseJSON(root.dataset.tiers || '[]', []);
    if (!Array.isArray(tiers)) tiers = [];
    tiers = tiers.map(function (t, i) {
      var c = (cfg.tiers && cfg.tiers[i]) || {};
      return { qty: parseInt(t.qty, 10) || 0, pct: parseInt(t.pct, 10) || 0, perk: c.perk || '' };
    }).filter(function (t) { return t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
    var topQty = tiers.length ? tiers[tiers.length - 1].qty : minJars;

    /* ---- elements ---- */
    var tierEls = [].slice.call(root.querySelectorAll('[data-box-tier]')).sort(function (a, b) {
      return (parseInt(a.dataset.qty, 10) || 0) - (parseInt(b.dataset.qty, 10) || 0);
    });
    var progressText = root.querySelector('[data-box-progress-text]');
    (function placeMarks() {
      var labels = [].slice.call(root.querySelectorAll('[data-box-bar-label]'));
      var ticks = [].slice.call(root.querySelectorAll('[data-box-bar-tick]'));
      var nM = tiers.length;
      if (!nM) return;
      labels.forEach(function (el, i) {
        if (i >= nM) { el.hidden = true; return; }
        el.style.width = (100 / nM) + '%';
        el.classList.toggle('is-last', i === nM - 1);
      });
      ticks.forEach(function (el, i) {
        if (i >= nM - 1) { el.hidden = true; return; }
        el.style.left = ((i + 1) / nM * 100) + '%';
      });
    })();
    var bar = root.querySelector('[data-box-bar]');
    var barFill = root.querySelector('[data-box-bar-fill]');
    var modeInputs = [].slice.call(root.querySelectorAll('[data-box-mode-input]'));
    var summaryEl = root.querySelector('[data-box-summary]');
    var summaryTitle = root.querySelector('[data-box-summary-title]');
    var slots = [].slice.call(root.querySelectorAll('[data-box-slots] .b2x-slot'));
    var slotMore = root.querySelector('[data-box-slot-more]');
    var shipEl = root.querySelector('[data-box-ship]');
    var giftEl = root.querySelector('[data-box-gift]');
    var gift2El = root.querySelector('[data-box-gift2]');
    var savingsEl = root.querySelector('[data-box-savings]');
    var subNoteEl = root.querySelector('[data-box-subnote]');
    var subtotalEl = root.querySelector('[data-box-subtotal]');
    var totalEl = root.querySelector('[data-box-total]');
    var cta = root.querySelector('[data-box-cta]');
    var mini = root.querySelector('[data-box-mini]');
    var miniFill = root.querySelector('[data-box-mini-fill]');
    var miniCount = root.querySelector('[data-box-mini-count]');
    var miniProgress = root.querySelector('[data-box-mini-progress]');
    var miniCta = root.querySelector('[data-box-mini-cta]');
    var ctaText = cta && cta.querySelector('[data-box-cta-text]');
    var errorEl = root.querySelector('[data-box-error]');

    var items = [].map.call(root.querySelectorAll('[data-box-item]'), function (el) {
      return {
        el: el,
        id: el.dataset.variantId,
        price: parseInt(el.dataset.price, 10) || 0,
        subPrice: /^\d+$/.test((el.dataset.subPrice || '').trim()) ? parseInt(el.dataset.subPrice, 10) : null,
        plan: (el.dataset.sellingPlan || '').trim(),
        color: (el.dataset.color || '').trim(),
        image: (el.dataset.image || '').trim(),
        group: (el.dataset.group || '').trim(),
        title: el.dataset.title || '',
        qty: 0,
        countEl: el.querySelector('[data-box-count]'),
        dec: el.querySelector('[data-box-dec]'),
        inc: el.querySelector('[data-box-inc]')
      };
    });

    var mode = 'once';
    if (modeInputs.length) {
      var checked = modeInputs.filter(function (i) { return i.checked; })[0];
      mode = checked ? checked.value : (root.dataset.defaultMode === 'sub' ? 'sub' : 'once');
    }
    var busy = false;

    /* ---- derived state ---- */
    function compute() {
      var count = 0, subtotal = 0, base = 0, hasNoPlan = false, picks = [];
      var sub = mode === 'sub';
      items.forEach(function (it) {
        if (!it.qty) return;
        count += it.qty;
        subtotal += it.qty * it.price;
        var unit = (sub && it.plan && it.subPrice !== null) ? it.subPrice : it.price;
        base += it.qty * unit;
        if (!it.plan) hasNoPlan = true;
        for (var i = 0; i < it.qty; i++) picks.push({ img: it.image, color: it.color, group: it.group, title: it.title });
      });
      var tierIdx = -1;
      tiers.forEach(function (t, i) { if (count >= t.qty) tierIdx = i; });
      var tierPct = tierIdx >= 0 ? tiers[tierIdx].pct : 0;
      var total = Math.round(base * (100 - tierPct) / 100);
      var next = null;
      for (var n = 0; n < tiers.length; n++) { if (tiers[n].qty > count) { next = tiers[n]; break; } }
      return {
        count: count, subtotal: subtotal, tierIdx: tierIdx, tierPct: tierPct,
        total: total, savings: subtotal - total, next: next, hasNoPlan: hasNoPlan, picks: picks
      };
    }

    /* ---- render ---- */
    function render() {
      var s = compute();

      items.forEach(function (it) {
        if (it.countEl) it.countEl.textContent = it.qty;
        if (it.dec) it.dec.disabled = it.qty === 0;
        if (it.inc) it.inc.disabled = it.qty >= 99;
        it.el.classList.toggle('is-selected', it.qty > 0);
      });

      tierEls.forEach(function (el, i) {
        el.classList.toggle('is-active', i === s.tierIdx);
        el.classList.toggle('is-reached', i <= s.tierIdx);
        el.setAttribute('aria-current', i === s.tierIdx ? 'true' : 'false');
      });

      /* One scale across all tiers: tier i unlocks at (i+1)/n of the bar, the fill
         is linear between tier points, so it only ever grows as jars are added. */
      var nT = tiers.length, fraction = 0;
      if (!nT) {
        fraction = Math.min(1, s.count / Math.max(1, minJars));
      } else if (s.count >= tiers[nT - 1].qty) {
        fraction = 1;
      } else {
        var prevQty = 0, prevPos = 0;
        for (var ti = 0; ti < nT; ti++) {
          var pos = (ti + 1) / nT;
          if (s.count < tiers[ti].qty) {
            fraction = prevPos + ((s.count - prevQty) / (tiers[ti].qty - prevQty)) * (pos - prevPos);
            break;
          }
          prevQty = tiers[ti].qty; prevPos = pos;
        }
      }
      if (barFill) barFill.style.width = (fraction * 100) + '%';
      if (bar) {
        bar.setAttribute('aria-valuemax', topQty);
        bar.setAttribute('aria-valuenow', Math.min(s.count, topQty));
      }
      if (progressText) {
        progressText.textContent = s.next
          ? fill(text.progressText, {
              n: s.next.qty - s.count, next: s.next.pct + '% off', pct: s.next.pct,
              qty: s.next.qty, perk: s.next.perk, count: s.count, min: minJars
            }, s.next.qty - s.count)
          : fill(text.progressDone, { count: s.count, min: minJars }, s.count);
      }

      if (summaryTitle) summaryTitle.textContent = fill(text.summaryTitle, { count: s.count }, s.count);

      slots.forEach(function (slot, i) {
        var p = s.picks[i];
        slot.classList.toggle('is-filled', !!p);
        slot.classList.toggle('has-image', !!(p && p.img));
        if (p && p.img) slot.style.backgroundImage = 'url("' + p.img + '")'; else slot.style.backgroundImage = '';
        if (p && p.color) slot.style.setProperty('--b2x-slot', p.color); else slot.style.removeProperty('--b2x-slot');
        if (p) { slot.setAttribute('data-group', p.group || ''); slot.title = p.title || ''; }
        else { slot.removeAttribute('data-group'); slot.removeAttribute('title'); }
      });
      if (slotMore) {
        var over = s.count - slots.length;
        slotMore.hidden = over <= 0;
        slotMore.textContent = over > 0 ? '+' + over : '';
      }

      if (shipEl) {
        if (shipThreshold > 0) {
          shipEl.hidden = false;
          shipEl.textContent = s.count >= shipThreshold
            ? fill(text.shipUnlocked, { count: s.count }, s.count)
            : fill(text.shipLocked, { n: shipThreshold - s.count, count: s.count }, shipThreshold - s.count);
        } else {
          shipEl.hidden = true;
        }
      }
      if (giftEl) giftEl.hidden = !(giftThreshold > 0 && s.count >= giftThreshold);
      if (gift2El) gift2El.hidden = !(gift2Threshold > 0 && s.count >= gift2Threshold);
      if (savingsEl) {
        savingsEl.textContent = s.savings > 0
          ? fill(text.savingsText, {
              amount: money(s.savings), pct: Math.round(s.savings * 100 / s.subtotal), count: s.count
            }, s.count)
          : fill(text.savingsLocked, { min: minJars, count: s.count }, minJars);
      }
      if (subNoteEl) subNoteEl.hidden = !(mode === 'sub' && s.hasNoPlan && s.count > 0);
      if (subtotalEl) {
        subtotalEl.hidden = !(s.total < s.subtotal);
        subtotalEl.textContent = s.total < s.subtotal ? money(s.subtotal) : '';
      }
      if (totalEl) totalEl.textContent = s.count > 0 ? money(s.total) : '';
      if (summaryEl) summaryEl.classList.toggle('is-empty', s.count === 0);

      if (cta && !busy) {
        var canAdd = s.count >= minJars;
        cta.disabled = !canAdd;
        var label = canAdd
          ? fill(text.ctaLabel, { total: money(s.total), count: s.count }, s.count)
          : fill(text.ctaLockedLabel, { min: minJars, count: s.count }, minJars);
        if (ctaText) ctaText.textContent = label; else cta.textContent = label;
      }

      var unit = fill(text.stickyUnit, {}, s.count);
      var stickyText = s.count > 0 ? s.count + ' ' + unit + ' · ' + money(s.total) : '';

      if (mini) {
        if (miniFill) miniFill.style.width = (fraction * 100) + '%';
        if (miniCount) miniCount.textContent = s.count > 0 ? stickyText : '0 ' + unit;
        if (miniProgress && progressText) miniProgress.textContent = progressText.textContent;
        if (miniCta && !busy) {
          miniCta.textContent = s.count >= minJars
            ? fill(text.miniCta, { total: money(s.total), count: s.count }, s.count)
            : fill(text.miniCtaLocked, { min: minJars, count: s.count }, minJars);
        }
      }
      [].forEach.call(document.querySelectorAll('[data-belo-sticky-price]'), function (el) {
        el.textContent = stickyText;
      });
    }

    function setQty(it, n) {
      it.qty = Math.max(0, Math.min(99, n));
      hideError();
      render();
    }

    items.forEach(function (it) {
      if (it.inc) it.inc.addEventListener('click', function () { setQty(it, it.qty + 1); });
      if (it.dec) it.dec.addEventListener('click', function () { setQty(it, it.qty - 1); });
    });

    modeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        mode = input.value === 'sub' ? 'sub' : 'once';
        modeInputs.forEach(function (i) {
          var card = i.closest('.b2x-mode-card');
          if (card) card.classList.toggle('is-selected', i === input);
        });
        hideError();
        render();
      });
    });

    /* ---- errors + loading ---- */
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function hideError() {
      if (errorEl && !errorEl.hidden) { errorEl.hidden = true; errorEl.textContent = ''; }
    }
    function setLoading(on) {
      busy = on;
      if (!cta) return;
      cta.classList.toggle('is-loading', on);
      cta.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) {
        cta.disabled = true;
        if (ctaText) ctaText.textContent = text.ctaLoading;
      } else {
        render();
      }
    }

    /* ---- add to cart (same sequence as component-product-form.js) ---- */
    function cartUrl(path) {
      var r = window.routes || {};
      var base = (path === 'add' ? r.cart_add_url : r.cart_url) || ('/cart' + (path === 'add' ? '/add' : ''));
      if (!/\.js$/.test(base)) base += '.js';
      return base;
    }

    function updateCartCount() {
      try {
        var r = window.routes || {};
        fetch((r.cart_url || '/cart') + '?view=compare')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
          })
          .catch(function () { /* count indicator is cosmetic */ });
      } catch (e) { /* ignore */ }
    }

    function addToCart() {
      if (busy) return;
      var s = compute();
      if (s.count < minJars) return;

      var lines = [];
      items.forEach(function (it) {
        if (!it.qty) return;
        var line = { id: parseInt(it.id, 10), quantity: it.qty, properties: { _belo_box: '1' } };
        if (mode === 'sub' && it.plan) line.selling_plan = parseInt(it.plan, 10);
        lines.push(line);
      });
      if (giftAdd && giftThreshold > 0 && s.count >= giftThreshold) {
        lines.push({ id: parseInt(giftVariant, 10), quantity: 1, properties: { _belo_gift: '1' } });
      }
      if (gift2Add && gift2Threshold > 0 && s.count >= gift2Threshold) {
        lines.push({ id: parseInt(gift2Variant, 10), quantity: 1, properties: { _belo_gift: '2' } });
      }

      hideError();
      setLoading(true);

      fetch(cartUrl('add'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: lines, sections: 'cart-drawer' })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) {
            return { ok: res.ok, status: res.status, json: json || {} };
          });
        })
        .then(function (r) {
          if (!r.ok) {
            showError(r.json.description || r.json.message || text.errorGeneric);
            return;
          }
          var bus = window.eventBus;
          if (bus && typeof bus.emit === 'function') {
            if (r.json.sections) bus.emit('update:cart:drawer', r.json);
            else bus.emit('render:cart:drawer');
            bus.emit('open:cart:drawer', { scrollToTop: true });
            bus.emit('cart:added', { sectionId: root.dataset.sectionId });
            updateCartCount();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          showError(text.errorGeneric);
        })
        .then(function () {
          setLoading(false);
        });
    }

    if (cta) cta.addEventListener('click', addToCart);
    if (miniCta) {
      miniCta.addEventListener('click', function () {
        if (compute().count >= minJars) { addToCart(); return; }
        var firstGroup = root.querySelector('[data-box-group]');
        if (firstGroup) firstGroup.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---- mini summary: visible while the builder is on screen but its summary card is still below the fold ---- */
    if (mini && summaryEl) {
      var firstGroup = root.querySelector('[data-box-group]');
      var miniTick = false;
      var updateMini = function () {
        miniTick = false;
        var vh = window.innerHeight;
        var reached = firstGroup ? firstGroup.getBoundingClientRect().top < vh - 120 : true;
        var summaryBelow = summaryEl.getBoundingClientRect().top > vh;
        var inBuilder = root.getBoundingClientRect().bottom > 0;
        mini.hidden = !(reached && summaryBelow && inBuilder);
      };
      var queueMini = function () { if (!miniTick) { miniTick = true; window.requestAnimationFrame(updateMini); } };
      window.addEventListener('scroll', queueMini, { passive: true });
      window.addEventListener('resize', queueMini);
      updateMini();
    }

    /* ---- sticky bar: show once the builder has scrolled out of view ---- */
    var stickyBar = document.getElementById('beloStickyBar');
    if (stickyBar && 'IntersectionObserver' in window) {
      if (stickyBar.__beloBoxIO) stickyBar.__beloBoxIO.disconnect();
      var io = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0 });
      stickyBar.__beloBoxIO = io;
      io.observe(root);
    }

    render();
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('.belo2-box'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    [].forEach.call(e.target.querySelectorAll('.belo2-box'), function (r) { delete r.dataset.boxInit; });
    initAll(e.target);
  });
})();
